export const Theme = {
  inter: "'Inter', Helvetica, Arial, sans-serif",
  green: {
    900: '#13434E',
    800: '#11555E',
    700: '#128087',
    600: '#0D9488',
    500: '#14B8A6',
    400: '#2DD4BF',
    300: '#5EEAD4',
    200: '#99F6E4',
    100: '#CCFBF1',
    50: '#F0FDFA',
  },
  red: {
    900: '#7F1D1D',
    800: '#991B1B',
    700: '#B91C1C',
    600: '#DC2626',
    500: '#EF4444',
    400: '#F87171',
    300: '#FCA5A5',
    200: '#FECACA',
    100: '#FEE2E2',
    50: '#FEF2F2',
  },
  neutral: {
    900: '#0F172A',
    800: '#1E293B',
    700: '#334155',
    600: '#475569',
    500: '#64748B',
    400: '#94A3B8',
    300: '#CBD5E1',
    200: '#E2E8F0',
    100: '#F1F5F9',
    50: '#F8FAFC',
    '000': '#FFFFFF',
  },
};
